import { lazy } from 'react'
import langConfig from "@configs/langConfig"
const {t} = langConfig
export default [
    // {
    //     path: '/user/dashboard',
    //     title : t('Dashboard'),
    //     component: lazy(() => import('../../../views/user/Home')),
    // },
    {
        path: '/user/phishing-feeds/',
        title : t('Phishing feeds'),
        component: lazy(() => import('../../../views/user/phishing-feed/index')),
        exact : true
    },
    {
        path: '/user/phishing-feed/:id',
        title : t('Phishing feed'),
        component: lazy(() => import('../../../views/user/phishing-feed/Show')),
    },
]